import { render } from "./PendingRiderInfo.vue?vue&type=template&id=0b48be8b"
import script from "./PendingRiderInfo.vue?vue&type=script&lang=js"
export * from "./PendingRiderInfo.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__